import axios from 'axios';

import { ApiPath } from 'enums';

export const authServiceClient = axios.create({
  baseURL: ApiPath.auth,
  headers: {
    'Content-Type': 'application/json',
  },
});
